import './SetupAuditTrailView.scss';

import { AsyncStateNotification } from '@ui/notifications';
import { CreateMonitorModal } from '@security/monitors/MonitorModal';
import { createSonarSelector } from '@lib/selectors';
import { getPastDate } from '@sonar-software/sonar-ts-lib';
import { monitorMenuConfigs } from '@security/monitors/monitor-form/MonitorMenu';
import { SetupAuditTrailGraph } from './SetupAuditTrailGraph';
import { SetupAuditTrailTable } from './SetupAuditTrailTable';
import { useBoolean } from '@hooks';
import { When } from 'react-if';

import { Button, Space } from 'antd';
import {
	ClassificationLevel,
	coreActions,
	DataSecurityMonitorType,
	SetupAuditTrailMonitor
} from '@sonar-software/sonar-core';
import { COPY_GENERIC, COPY_SPECIFIC, SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { DateRangePicker, DateRangePickerParams } from '@ui/DateRangePicker';
import React, { useCallback, useState } from 'react';
import { SonarCard, ViewArea } from '@ui/general';

const postMonitorSelectors = createSonarSelector((state) => state.core.dataSecurity.monitors.post);

export const SetupAuditTrailViewArea: React.FC = () => {
	const [ dateRange, setDateRange ] = useState<DateRangePickerParams>({ start: getPastDate(30) });
	const [ classificationsFilter, setClassificationsFilter ] = useState<Array<ClassificationLevel>>([]);
	const [ showModal, setShowModal ] = useBoolean(false);

	const satMonitorConfig = monitorMenuConfigs.find((x) => x.type === DataSecurityMonitorType.SetupAuditTrail);

	const [ currentMonitor, setCurrentMonitor ] = useState(satMonitorConfig?.default);

	const handleCancel = useCallback(() => {
		setShowModal.off();
		setCurrentMonitor(satMonitorConfig?.default);
	}, [ satMonitorConfig?.default, setShowModal ]);

	return (
		<ViewArea
			collapseSidebar
			direction='horizontal'
			fullWidth
			id='setup-audit-trail-view'>
			<div className='setup-audit-trail-view-content'>
				<SonarCard
					className='setup-audit-trail-view-header'
					extra={
						<Space size='middle'>
							<DateRangePicker
								endDate={ dateRange.end }
								onChange={ setDateRange }
								startDate={ dateRange.start } />
							<Button
								className='create-monitor-button'
								onClick={ setShowModal.on }
								type='primary'>
								{ COPY_SPECIFIC.CREATE_MONITOR }
							</Button>
						</Space>
					}
					title={ COPY_SPECIFIC.SETUP_AUDIT_TRAIL }>
					<When condition={ satMonitorConfig?.active }>
						<CreateMonitorModal
							defaultMonitor={ satMonitorConfig?.default }
							menuOptions='hide'
							monitor={ currentMonitor as SetupAuditTrailMonitor }
							onCancel={ handleCancel }
							onChange={ setCurrentMonitor }
							onSave={ setShowModal.off }
							open={ showModal }
							title={ COPY_SPECIFIC.MONITOR_BUILDER } />
					</When>
				</SonarCard>
				<SetupAuditTrailGraph
					classificationsFilter={ classificationsFilter }
					dateRange={ dateRange }
					onClassificationFilterChange={ setClassificationsFilter } />
				<SetupAuditTrailTable
					classificationsFilter={ classificationsFilter }
					dateRange={ dateRange }
					onClassificationFilterChange={ setClassificationsFilter } />
				<AsyncStateNotification
					errored={ COPY_GENERIC.CONTACT_SUPPORT }
					failed={ COPY_GENERIC.CONTACT_SUPPORT }
					received={ SETTINGS_DATA_SECURITY_COPY.MONITOR_SAVED }
					resetRawAction={ coreActions.resetPostCoreDataSecurityMonitors }
					stateSelector={ postMonitorSelectors } />
			</div>
		</ViewArea>
	);
};
